const EVENTS_PREFIX = 'ESS Setup Flow'

const STEP_0_PREFIX = `${EVENTS_PREFIX} Step 0 (Introduction)`
const STEP_1_PREFIX = `${EVENTS_PREFIX} Step 1 (Microsoft connect)`
const STEP_2_PREFIX = `${EVENTS_PREFIX} Step 2 (Region select)`
const STEP_3_PREFIX = `${EVENTS_PREFIX} Step 3 (Verify domain)`
const STEP_4_PREFIX = `${EVENTS_PREFIX} Step 4 (Deployment setup)`
const STEP_5_PREFIX = `${EVENTS_PREFIX} Step 5 (Email flow)`
const STEP_6_PREFIX = `${EVENTS_PREFIX} Step 6 (Setup complete)`

const SETUP_FLOW_EVENTS = {
  START: `${EVENTS_PREFIX} Started`,
  CLOSE: `${EVENTS_PREFIX} Close`,
  SAVE_AND_EXIT: `${EVENTS_PREFIX} Save and Exit`,
  NEXT: `${EVENTS_PREFIX} Next`,
  COMPLETE: `${EVENTS_PREFIX} Complete`,

  // Introduction selection
  STEP_0_START: `${STEP_0_PREFIX} Pageview`,

  // Microsoft connect selection
  STEP_1_START: `${STEP_1_PREFIX} Pageview`,
  STEP_1_SKIP: `${STEP_1_PREFIX} Skip`,
  STEP_1_SKIP_CONFIRM: `${STEP_1_PREFIX} Skip confirm`,
  STEP_1_SKIP_CANCEL: `${STEP_1_PREFIX} Skip cancel`,
  STEP_1_CONNECT: `${STEP_1_PREFIX} Connect`,
  STEP_1_SCAN_STATUS: `${STEP_1_PREFIX} Scan status`,

  // Region selection
  STEP_2_START: `${STEP_2_PREFIX} Pageview`,
  STEP_2_REGION_CHANGE: `${STEP_2_PREFIX} Region change`,

  // Verify domain MS
  STEP_3_START_MICROSOFT: `${STEP_3_PREFIX} Pageview microsoft domains`,
  STEP_3_SELECT_DOMAIN: `${STEP_3_PREFIX} Select microsoft domain`,
  // Verify domain
  STEP_3_START: `${STEP_3_PREFIX} Pageview`,
  STEP_3_DETECT_EMAIL_SERVER: `${STEP_3_PREFIX} Detect email server`,
  STEP_3_EDIT_EMAIL_SERVER: `${STEP_3_PREFIX} Edit email server`,
  STEP_3_CHANGE_EMAIL_SERVER: `${STEP_3_PREFIX} Change email server`,
  STEP_3_VERIFY_SERVER: `${STEP_3_PREFIX} Verify server`,

  // Deployment setup
  STEP_4_START: `${STEP_4_PREFIX} Pageview`,
  STEP_4_LEARN_MORE: `${STEP_4_PREFIX} Learn more`,
  STEP_4_CHANGE: `${STEP_4_PREFIX} Deployment method change`,

  // Email flow (INLINE)
  STEP_5_START_INLINE: `${STEP_5_PREFIX} Pageview Inline`,
  STEP_5_CHANGE_TO_MX: `${STEP_5_PREFIX} Change deployment method to MX`,

  // Email flow (MX)
  STEP_5_START: `${STEP_5_PREFIX} Pageview MX`,
  STEP_5_VISIT_PROVIDER_URL: `${STEP_5_PREFIX} Provider url`,
  STEP_5_VISIT_ADD_MX_LINK_URL: `${STEP_5_PREFIX} Add MX link url`,
  STEP_5_VERIFIY_RECORDS: `${STEP_5_PREFIX} Verify records`,
  STEP_5_VISIT_EDIT_MX_LINK_URL: `${STEP_5_PREFIX} Edit MX link url`,
  STEP_5_VERIFIY_UPDATE: `${STEP_5_PREFIX} Verify update`,

  // Setup complete page
  STEP_6_START: `${STEP_6_PREFIX} Pageview`
} as const

export default SETUP_FLOW_EVENTS
